import HeaderBox from 'component/PageModalHeaderBox'

import { BlockColor, Narrative, BlockContent, QqIcon, BtnContact, StyledPageScrollWrap } from './Styled'
import { HeaderWrap, PageWrapperNonScroll } from 'commonStyledComponents'
import { useEffect, useState } from 'react'
import { fetchCooperation } from 'api'
import EmptyResult from 'component/EmptyResult'
import { catchPromiseCancel } from 'utils/catchPromiseCancel'
import themeAsseticonTgIconPng from '@theme/icon/tg-icon.png'
import themeAsseticonQqIconPng from '@theme/icon/qq-icon.png'

/**
 * @param {import('../../../types/api').SchemaCooperation} coop cooperation
 */
const onBtnContactClick = (coop: any) => {
  window.open(coop.link, '_blank')
}

export default function BusinessRelationship() {
  const [coops, setCoops] = useState<any[]>([])
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    fetchCooperation({ signal })
      .then((res: any) => {
        setCoops(res.data)
        setLoaded(true)
      })
      .catch(catchPromiseCancel)

    return () => {
      controller.abort()
    }
  }, [])

  return (
    <PageWrapperNonScroll>
      <HeaderWrap>
        <HeaderBox
          headerTitle={'商务合作'}
          onClose={({ close }: { close: () => void }) => {
            close()
          }}
        />
      </HeaderWrap>
      <StyledPageScrollWrap>
        {coops.map((coop, index) => (
          <BlockColor key={index}>
            {coop.link_type === 1 ? <QqIcon src={themeAsseticonTgIconPng} /> : <QqIcon src={themeAsseticonQqIconPng} />}
            <BlockContent>
              <Narrative>
                <p>{coop.name}</p>
                <p>{coop.desc}</p>
              </Narrative>
              <BtnContact onClick={() => onBtnContactClick(coop)}>立即加入</BtnContact>
            </BlockContent>
          </BlockColor>
        ))}

        {loaded && coops.length === 0 && <EmptyResult style={{ height: 'calc(100% - 2rem)' }} />}
      </StyledPageScrollWrap>
    </PageWrapperNonScroll>
  )
}
